export const getCurrentRelativeUrl = () => {
  const { pathname, search, hash } = window.location;
  return `${pathname}${search}${hash}`;
};

export const safeDecodeRedirect = (raw: string | null): string | null => {
  if (!raw) return null;

  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return null;
  }

  if (!decoded.startsWith('/') || decoded.startsWith('//')) return null;
  if (decoded.includes('\\') || decoded.includes('://')) return null;

  return decoded;
};
